// extracted by mini-css-extract-plugin
module.exports = {"Container":"PhoneBlock_Container__RKKzD","Record":"PhoneBlock_Record__4vHqI"};